import React, { useState, useEffect, useRef } from "react";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import uuid from "react-uuid";
import { Formik } from "formik";
import KnowledgeOrSkillsForm from "./KnowledgeOrSkillsForm";
import WarningNotiifcation from "components/WarningNotification";
import { SetLoading } from "redux/actions/loadingActions";
import { SetUser } from "redux/actions/userActions";
import { connect } from "react-redux";
import { updateMany, get } from "services";
import { isBrowser } from "react-device-detect";
import { SetOperationSuccess } from "redux/actions/operationSuccessActions";
import { SetHasKnowledge } from "redux/actions/hasKnowledgeDataActions";
import Spinner from "react-bootstrap/Spinner";
import { useHistory } from "react-router";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

let yup = require("yup");

const KnowledgeAndSkillsFormWrapper = ({
  user,
  SetLoading,
  SetOperationSuccess,
  opeationSuccess,
  SetHasKnowledge,
  hasKnowledgeDataReducer,
}) => {
  const [knowledgeOrSkillsForm, setKnowledgeOrSkillsForm] = useState([]);
  const [loadForm, setLoadForm] = useState(false);
  const [formContent, setFormContent] = useState({});
  const [formikSchema, setFormikSchema] = useState({});
  const [basicSchema, setBasicSchema] = useState({});
  const [reCAPTCHA, setReCAPTCHA] = useState("");
  const formRef = useRef();
  const [saveAndContinue, setSaveAndContinue] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [lastIndex, setLastIndex] = useState(0);
  const [empresaId, setEmpresaId] = useState(96);

  const history = useHistory();

  useEffect(() => {
    (async function mounted() {
      if (
        !user.persona.personaConocimientos ||
        user.persona.personaConocimientos.length == 0
      ) {
        const response = await get(
          `PersonaConocimiento/GetByPersonaId/${user.persona.id}`
        );
        //debugger;
        user.persona.personaConocimientos = response.data;
      }

      if (user.esEmpleado) {
        const empresaId = await get(
          `Empleado/GetEmpresaIdByEmpleado/${user.persona.id}`
        );
        setEmpresaId(empresaId.data);
      }

      if (
        user.persona.personaConocimientos &&
        user.persona.personaConocimientos.length > 0
      ) {
        user.persona.personaConocimientos =
          user.persona.personaConocimientos.filter((x) => x);
        let schema = {};
        let values = {};
        let competencias = [];

        user.persona.personaConocimientos.forEach((competencia) => {
          const competenciaId = competencia.id;
          schema = {
            ...schema,
            [`knowledgeOrSkills_${competenciaId}`]: yup
              .number()
              .typeError("El campo es numérico")
              .required("El campo es requerido"),
            [`valoracion_${competenciaId}`]: yup
              .number()
              .typeError("El campo es numérico")
              .required("El campo es requerido"),
          };
          values = {
            ...values,
            [`knowledgeOrSkills_${competenciaId}`]: competencia.conocimientoId,
            [`valoracion_${competenciaId}`]: competencia.valoracion
              ? competencia.valoracion
              : 1,
          };
          competencias.push({
            id: competenciaId,
            estado: competencia.estado,
            isNew: false,
          });
        });
        setBasicSchema(() => {
          return schema;
        });
        updateFormik(schema);
        setFormContent(() => {
          return values;
        });
        setKnowledgeOrSkillsForm(() => {
          return [...competencias];
        });
      }

      setLoadForm(true);
    })();
  }, []);

  useEffect(() => {
    if (knowledgeOrSkillsForm && knowledgeOrSkillsForm.length > 0) {
      setLastIndex(knowledgeOrSkillsForm.map((x) => x.estado).lastIndexOf(1));
    }
    console.log(knowledgeOrSkillsForm);
  }, [knowledgeOrSkillsForm]);

  useEffect(() => {
    if (loadForm) {
      if (
        (user.persona.personaConocimientos &&
          user.persona.personaConocimientos.length == 0) ||
        user.persona.personaConocimientos.every((x) => x.estado == 0)
      ) {
        onAddKnowledgeOrSkillsForm();
      }
    }
  }, [loadForm]);

  // useEffect(() => {
  //     if (loadForm) {
  //         setTimeout(() => {
  //             if (knowledgeOrSkillsForm.length < 6 || knowledgeOrSkillsForm.filter(x => x.estado === 1).length < 6) {
  //                 onAddKnowledgeOrSkillsForm();
  //             }
  //         }, 10);
  //     }
  // }, [knowledgeOrSkillsForm])

  const onSaveAndContinue = () => {
    formRef.current.validateForm().then((data) => {
      if (Object.keys(data).length === 0 && data.constructor === Object) {
        setSaveAndContinue(true);
        formRef.current.handleSubmit();
      }
    });
  };

  const onSave = () => {
    formRef.current.validateForm().then((data) => {
      if (Object.keys(data).length === 0 && data.constructor === Object) {
        setSaveAndContinue(false);
        formRef.current.handleSubmit();
      }
    });
  };

  const onExit = () => {
    history.push({
      pathname: "/knowledgeAndSkillsModule",
      state: {
        updateUserData: true,
      },
    });
  };

  const updateFormik = (schema) =>
    setFormikSchema(() => {
      return yup.object(schema);
    });

  const onAddKnowledgeOrSkillsForm = () => {
    const guid = uuid();
    const oldValues = formRef.current.values;
    const newSchema = {
      ...basicSchema,
      [`knowledgeOrSkills_${guid}`]: yup
        .number()
        .typeError("El campo es numérico")
        .required("El campo es requerido"),
      [`valoracion_${guid}`]: yup
        .number()
        .typeError("El campo es numérico")
        .required("El campo es requerido"),
    };
    setBasicSchema(() => {
      return newSchema;
    });
    setFormContent(() => {
      return {
        ...oldValues,
        [`knowledgeOrSkills_${guid}`]: "",
        [`valoracion_${guid}`]: 1,
      };
    });

    setKnowledgeOrSkillsForm(() => {
      return [
        ...knowledgeOrSkillsForm,
        {
          id: guid,
          estado: 1,
          isNew: true,
        },
      ];
    });

    updateFormik(newSchema);
  };

  const onRemoveKnowledgeOrSkillsForm = (identifier) => {
    let newSchema = basicSchema;
    const oldValues = formRef.current.values;
    const removedForm = knowledgeOrSkillsForm.find((x) => x.id === identifier);
    const schemaKeys = [
      `knowledgeOrSkills_${identifier}`,
      `valoracion_${identifier}`,
    ];

    schemaKeys.forEach((key) => {
      delete newSchema[key];
      delete oldValues[key];
    });

    setBasicSchema(() => {
      return newSchema;
    });

    setFormContent(() => {
      return oldValues;
    });

    updateFormik(newSchema);

    if (removedForm.isNew) {
      setKnowledgeOrSkillsForm(() => {
        return [...knowledgeOrSkillsForm.filter((x) => x.id !== identifier)];
      });
    } else {
      removedForm.estado = 0;
      setKnowledgeOrSkillsForm(() => {
        return [...knowledgeOrSkillsForm];
      });
    }
  };

  const notify = (text) =>
    toast.warn(text, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const onFormSubmitted = async (form) => {
    let personaConocimientos = [];
    let onCancelOperation = {
      cancelOperation: false,
      skills: [],
    };
    knowledgeOrSkillsForm.forEach((competencia) => {
      const conocimientoId = Number(
        competencia.estado == 0
          ? user.persona.personaConocimientos.find(
              (x) => x.id == competencia.id
            )?.conocimientoId
          : form["knowledgeOrSkills_" + competencia.id]
      );
      const valoracion = Number(
        competencia.estado == 0
          ? user.persona.personaConocimientos.find(
              (x) => x.id == competencia.id
            )?.valoracion
          : form["valoracion_" + competencia.id]
      );
      const personaCompetencia = {
        id: competencia.isNew ? null : competencia.id,
        personaId: user.persona.id,
        estado: competencia.estado,
        conocimientoId,
        valoracion,
      };

      if (personaConocimientos) {
        if (
          personaConocimientos.some(
            (personaConocimiento) =>
              personaConocimiento.conocimientoId == conocimientoId
          )
        ) {
          if (!onCancelOperation.skills.some((x) => x == conocimientoId)) {
            onCancelOperation.skills.push(conocimientoId);
          }
          onCancelOperation.cancelOperation = true;
        }
      }

      personaConocimientos.push(personaCompetencia);
    });

    if (onCancelOperation.cancelOperation) {
      onCancelOperation.skills.forEach(async (skillId) => {
        const item = await get("Conocimiento?$filter=id eq " + skillId);
        notify(
          "No puede agregar el conocimiento o habilidad " +
            item.data[0].descripcion +
            " más de una vez"
        );
      });
      return;
    }

    setIsLoading(true);

    const response = await updateMany(
      "PersonaConocimiento",
      personaConocimientos /* , reCAPTCHA */
    );
    user.persona = {
      ...user.persona,
      personaConocimientos: [...response.data],
    };
    SetUser(user);
    localStorage.setItem("currentUser-ARS", JSON.stringify(user));
    SetOperationSuccess(opeationSuccess + 1);

    if (response && response.data && response.data.some((x) => x.estado == 1)) {
      SetHasKnowledge(true);
    } else {
      SetHasKnowledge(false);
    }

    setIsLoading(false);

    const route = saveAndContinue ? "/experience" : "/knowledgeAndSkillsModule";
    history.push({
      pathname: route,
      state: {
        updateUserData: true,
      },
    });
  };

  return (
    <>
      <ToastContainer />
      {isLoading && (
        <div className={"display-flex flex-direction-row flex-center"}>
          <Spinner
            animation="grow"
            variant="primary"
            className={"is-absolute center-spinner-vertically"}
            size="lg"
          />
        </div>
      )}
      <Card>
        <Card.Body className={"p-40"}>
          {loadForm && (
            <div>
              <Formik
                innerRef={formRef}
                validationSchema={formikSchema}
                onSubmit={onFormSubmitted}
                initialValues={formContent}
                enableReinitialize={true}
                validateOnChange={false}
                validateOnBlur={false}
              >
                {({
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  values,
                  touched,
                  isValid,
                  errors,
                }) => (
                  <Form noValidate onSubmit={handleSubmit}>
                    <Form.Row>
                      <Form.Group as={Col} md="12" className="mb-0">
                        <div className={"display-flex space-between"}>
                          <div style={{ fontSize: 18 }}>
                            <b> Campos obligatorios * </b>
                          </div>
                          {
                            // isBrowser &&
                            // <div style={{fontSize: 20}}>
                            //     <b> Total conocimientos y habilidades: </b> { knowledgeOrSkillsForm.filter(x => x.estado == 1).length }/15
                            // </div>
                          }
                        </div>
                      </Form.Group>

                      <Form.Group as={Col} md="12" className="mb-25">
                        <span style={{ fontSize: 18 }}>
                          {" "}
                          Seleccione sus conocimientos o habilidades indicando
                          su nivel de dominio con las estrellas.{" "}
                        </span>
                      </Form.Group>

                      {/* <Form.Group as={Col} md="12">
                                                {
                                                    (knowledgeOrSkillsForm.length > 0 && knowledgeOrSkillsForm.filter(x => x.estado == 1).length >= 15) && 
                                                    <div className="alert alert-warning" role="alert">
                                                        <ul style={{ marginBottom: 0, paddingLeft: 20}}>
                                                            <li> Ha alcanzado el <b> máximo de conocimientos y habilidades </b> </li>
                                                        </ul>
                                                    </div>
                                                }
                                            </Form.Group> */}

                      {knowledgeOrSkillsForm.length > 0 ? (
                        knowledgeOrSkillsForm
                          .filter(
                            (x) =>
                              x.estado == 1 &&
                              `knowledgeOrSkills_${x.id}` in values
                          )
                          .map((element, i) => {
                            return (
                              <KnowledgeOrSkillsForm
                                index={i}
                                lastIndex={lastIndex}
                                key={element.id}
                                handleChange={handleChange}
                                errors={errors}
                                touched={touched}
                                values={values}
                                element={element}
                                empresaId={empresaId}
                                removeKnowledgeOrSkillsForm={
                                  onRemoveKnowledgeOrSkillsForm
                                }
                              />
                            );
                          })
                      ) : (
                        <Form.Group as={Col} md="12">
                          <WarningNotiifcation
                            message="No ha agregado formularios a la sección "
                            enphasis="Conocimientos y habilidades"
                          />
                        </Form.Group>
                      )}

                      <Form.Group as={Col} md="12">
                        <div className={"display-flex flex-end"}>
                          <Button
                            disabled={
                              knowledgeOrSkillsForm.filter((x) => x.estado == 1)
                                .length >= 15
                            }
                            onClick={onAddKnowledgeOrSkillsForm}
                          >
                            Agregar
                            {/* {' '} { knowledgeOrSkillsForm.filter(x => x.estado == 1).length }/15   */}
                          </Button>
                        </div>
                      </Form.Group>
                    </Form.Row>

                    {knowledgeOrSkillsForm.length > 0 && (
                      <Form.Group
                        className={"display-flex space-between padding-right-0"}
                        as={Col}
                        md="12"
                      >
                        {hasKnowledgeDataReducer ? (
                          <Button
                            size="medium"
                            variant="light"
                            onClick={onExit}
                          >
                            {" "}
                            <b> Cancelar edición </b>{" "}
                          </Button>
                        ) : (
                          <div> </div>
                        )}
                        <div>
                          <Button size="medium" type="button" onClick={onSave}>
                            {" "}
                            <b> Guardar </b>{" "}
                          </Button>
                          <Button
                            className={"margin-left-5"}
                            size="medium"
                            type="button"
                            onClick={onSaveAndContinue}
                          >
                            {" "}
                            <b> Guardar y continuar </b>{" "}
                          </Button>
                        </div>
                      </Form.Group>
                    )}
                  </Form>
                )}
              </Formik>
            </div>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    opeationSuccess: state.opeationSuccess,
    hasKnowledgeDataReducer: state.hasKnowledgeDataReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    SetUser: (user) => dispatch(SetUser(user)),
    SetLoading: (value) => dispatch(SetLoading(value)),
    SetOperationSuccess: (value) => dispatch(SetOperationSuccess(value)),
    SetHasKnowledge: (value) => dispatch(SetHasKnowledge(value)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(KnowledgeAndSkillsFormWrapper);
